export default [
    'Main',
    'Header',
    'Navigation',
    'Dropdown',

    // Module
    'QuickStart',
    'Slider',
    'Video',
    'Parallax',
    'Counter',
    'CircularGraph',

    // Search
    'Search',
    'SearchOverlay',

    // Landing Pages
    'ArticleList',
    'ProjectList',
    'KnowledgeLibrary',
    'Careers',

    // Application Form
    'Tracker',
    'Questionnaire',
    'ProjectOverview',
    'BackAlert',
    'Cta',
    'FileUpload',
    'AddLink',
    'Wysiwyg',
    'ApplicationForm',
    'Summary',

    // Newsletter
    'Subscription',
]
